import { createStore } from 'redux';
import rootReducer from '../reducers';

const persistedState = localStorage.getItem('8)D_0!@1%9~^Y(') ? JSON.parse(localStorage.getItem('8)D_0!@1%9~^Y(')) : {};

const store = createStore(rootReducer, persistedState);
store.subscribe(() => {
	localStorage.setItem('8)D_0!@1%9~^Y(', JSON.stringify(store.getState()));
});

export default store;